import renderHeader from './header'
import renderItem from './item'
import bindHover from './bindHover'
import removeResultList from './removeResultList'
import { polylines } from '../polylines'

const renderResultList = routes => {
  removeResultList()

  let resultTable = `<div id="result-list">`
        resultTable += '<div class="content">'
          resultTable += '<ul>'

            for (let i = 0; i < routes.length; i++) {
              resultTable += renderItem(routes[i])
            }

          resultTable += '</ul>'
        resultTable += '</div>'
      resultTable += '</div>'

  $(resultTable).appendTo('body')

  bindHover($('#result-list .item'))

  // set offset to routes types
  $('#result-list .item').each((index, item) => {
    const itemWidth = $(item).find('.show-text').outerWidth()
    $(item).find('.show-text').css({left: `-${itemWidth / 2}px`})
  })

  // I use setTimeout othwerwise resultTable wont animate
  setTimeout(function() {
    $('#result-list').addClass('loaded')
    $('#airticket-map-offers ul').slick('slickPause') // puase slick slider
    $('#airticket-map-offers').addClass('hide') // hide slick slider
  }, 0)
}

export default renderResultList



// WEBPACK FOOTER //
// ./app/result-list/index.js